/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { ParametersLocation } from '../types';
// @ts-ignore
import type { ParametersModel } from '../types';
// @ts-ignore
import type { ParametersModelRun } from '../types';
// @ts-ignore
import type { ParametersModeledMapLayer } from '../types';
// @ts-ignore
import type { ParametersModeledMapLayerMetadata } from '../types';
// @ts-ignore
import type { ParametersModeledParameter } from '../types';
// @ts-ignore
import type { ParametersModeledTimeSeriesForCoordinatesResult } from '../types';
// @ts-ignore
import type { ParametersObservedMapLayer } from '../types';
// @ts-ignore
import type { ParametersObservedMapLayerMetadata } from '../types';
// @ts-ignore
import type { ParametersObservedParameter } from '../types';
// @ts-ignore
import type { ParametersObservedTimeSeriesForLocationResult } from '../types';
// @ts-ignore
import type { ParametersPropertyKind } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * ParametersApi - axios parameter creator
 * @export
 */
export const ParametersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a legend graphic for a modeled map layer
         * @summary Get legend graphic for modeled map layer
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerLegend: async (modelId: string, mapLayerId: string, referenceTime: string, time: string, vertical?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('getModeledMapLayerLegend', 'modelId', modelId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getModeledMapLayerLegend', 'mapLayerId', mapLayerId)
            // verify required parameter 'referenceTime' is not null or undefined
            assertParamExists('getModeledMapLayerLegend', 'referenceTime', referenceTime)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('getModeledMapLayerLegend', 'time', time)
            const localVarPath = `/parameters/models/{model_id}/map_layers/{map_layer_id}/legend`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (referenceTime !== undefined) {
                localVarQueryParameter['reference_time'] = referenceTime;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }

            if (vertical !== undefined) {
                localVarQueryParameter['vertical'] = vertical;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns metadata for a modeled map layer
         * @summary Get modeled map layer metadata
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerMetadata: async (modelId: string, mapLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('getModeledMapLayerMetadata', 'modelId', modelId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getModeledMapLayerMetadata', 'mapLayerId', mapLayerId)
            const localVarPath = `/parameters/models/{model_id}/map_layers/{map_layer_id}`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a map tile for a modeled map layer
         * @summary Get modeled map layer tile
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerTile: async (modelId: string, mapLayerId: string, referenceTime: string, time: string, x: number, y: number, z: number, vertical?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'modelId', modelId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'mapLayerId', mapLayerId)
            // verify required parameter 'referenceTime' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'referenceTime', referenceTime)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'time', time)
            // verify required parameter 'x' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'x', x)
            // verify required parameter 'y' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'y', y)
            // verify required parameter 'z' is not null or undefined
            assertParamExists('getModeledMapLayerTile', 'z', z)
            const localVarPath = `/parameters/models/{model_id}/map_layers/{map_layer_id}/tile`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (referenceTime !== undefined) {
                localVarQueryParameter['reference_time'] = referenceTime;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }

            if (x !== undefined) {
                localVarQueryParameter['x'] = x;
            }

            if (y !== undefined) {
                localVarQueryParameter['y'] = y;
            }

            if (z !== undefined) {
                localVarQueryParameter['z'] = z;
            }

            if (vertical !== undefined) {
                localVarQueryParameter['vertical'] = vertical;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time series data for a modeled parameter at specific coordinates
         * @summary Get modeled parameter time series for coordinates
         * @param {string} modelId 
         * @param {string} parameterId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledParameterTimeSeriesForCoordinates: async (modelId: string, parameterId: string, referenceTime: string, latitude: number, longitude: number, unit: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'modelId', modelId)
            // verify required parameter 'parameterId' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'parameterId', parameterId)
            // verify required parameter 'referenceTime' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'referenceTime', referenceTime)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'longitude', longitude)
            // verify required parameter 'unit' is not null or undefined
            assertParamExists('getModeledParameterTimeSeriesForCoordinates', 'unit', unit)
            const localVarPath = `/parameters/models/{model_id}/parameters/{parameter_id}/time_series`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)))
                .replace(`{${"parameter_id"}}`, encodeURIComponent(String(parameterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (referenceTime !== undefined) {
                localVarQueryParameter['reference_time'] = referenceTime;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a legend graphic for an observed map layer
         * @summary Get legend graphic for observed map layer
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerLegend: async (mapLayerId: string, time: string, vertical?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getObservedMapLayerLegend', 'mapLayerId', mapLayerId)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('getObservedMapLayerLegend', 'time', time)
            const localVarPath = `/parameters/observed/map_layers/{map_layer_id}/legend`
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }

            if (vertical !== undefined) {
                localVarQueryParameter['vertical'] = vertical;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns metadata for an observed map layer
         * @summary Get observed map layer metadata
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerMetadata: async (mapLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getObservedMapLayerMetadata', 'mapLayerId', mapLayerId)
            const localVarPath = `/parameters/observed/map_layers/{map_layer_id}`
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a map tile for an observed map layer
         * @summary Get observed map layer tile
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerTile: async (mapLayerId: string, time: string, x: number, y: number, z: number, vertical?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getObservedMapLayerTile', 'mapLayerId', mapLayerId)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('getObservedMapLayerTile', 'time', time)
            // verify required parameter 'x' is not null or undefined
            assertParamExists('getObservedMapLayerTile', 'x', x)
            // verify required parameter 'y' is not null or undefined
            assertParamExists('getObservedMapLayerTile', 'y', y)
            // verify required parameter 'z' is not null or undefined
            assertParamExists('getObservedMapLayerTile', 'z', z)
            const localVarPath = `/parameters/observed/map_layers/{map_layer_id}/tile`
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }

            if (x !== undefined) {
                localVarQueryParameter['x'] = x;
            }

            if (y !== undefined) {
                localVarQueryParameter['y'] = y;
            }

            if (z !== undefined) {
                localVarQueryParameter['z'] = z;
            }

            if (vertical !== undefined) {
                localVarQueryParameter['vertical'] = vertical;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns time series data for an observed parameter at a location
         * @summary Get observed parameter time series for location
         * @param {string} parameterId 
         * @param {string} locationId 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedParameterTimeSeriesForLocation: async (parameterId: string, locationId: string, unit: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parameterId' is not null or undefined
            assertParamExists('getObservedParameterTimeSeriesForLocation', 'parameterId', parameterId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getObservedParameterTimeSeriesForLocation', 'locationId', locationId)
            // verify required parameter 'unit' is not null or undefined
            assertParamExists('getObservedParameterTimeSeriesForLocation', 'unit', unit)
            const localVarPath = `/parameters/observed/parameters/{parameter_id}/locations/{location_id}/time_series`
                .replace(`{${"parameter_id"}}`, encodeURIComponent(String(parameterId)))
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all locations
         * @summary List locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns map layers for model
         * @summary List map layers for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMapLayersForModel: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('listMapLayersForModel', 'modelId', modelId)
            const localVarPath = `/parameters/models/{model_id}/map_layers`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest runs offered by every source of the model and fully tiled for every map layer, up to the model\'s run limit
         * @summary List runs for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModelRuns: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('listModelRuns', 'modelId', modelId)
            const localVarPath = `/parameters/models/{model_id}/runs`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all models
         * @summary List all models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all observed map layers
         * @summary List observed map layers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObservedMapLayers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/observed/map_layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all observed parameters
         * @summary List observed parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObservedParameters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/observed/parameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns parameters for model
         * @summary List parameters for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParametersForModel: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('listParametersForModel', 'modelId', modelId)
            const localVarPath = `/parameters/models/{model_id}/parameters`
                .replace(`{${"model_id"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all property kinds and their available display units
         * @summary List property kinds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPropertyKinds: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parameters/property_kinds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParametersApi - functional programming interface
 * @export
 */
export const ParametersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParametersApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a legend graphic for a modeled map layer
         * @summary Get legend graphic for modeled map layer
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModeledMapLayerLegend(modelId: string, mapLayerId: string, referenceTime: string, time: string, vertical?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModeledMapLayerLegend(modelId, mapLayerId, referenceTime, time, vertical, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getModeledMapLayerLegend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns metadata for a modeled map layer
         * @summary Get modeled map layer metadata
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModeledMapLayerMetadata(modelId: string, mapLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParametersModeledMapLayerMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModeledMapLayerMetadata(modelId, mapLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getModeledMapLayerMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a map tile for a modeled map layer
         * @summary Get modeled map layer tile
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModeledMapLayerTile(modelId: string, mapLayerId: string, referenceTime: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModeledMapLayerTile(modelId, mapLayerId, referenceTime, time, x, y, z, vertical, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getModeledMapLayerTile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns time series data for a modeled parameter at specific coordinates
         * @summary Get modeled parameter time series for coordinates
         * @param {string} modelId 
         * @param {string} parameterId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModeledParameterTimeSeriesForCoordinates(modelId: string, parameterId: string, referenceTime: string, latitude: number, longitude: number, unit: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParametersModeledTimeSeriesForCoordinatesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModeledParameterTimeSeriesForCoordinates(modelId, parameterId, referenceTime, latitude, longitude, unit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getModeledParameterTimeSeriesForCoordinates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a legend graphic for an observed map layer
         * @summary Get legend graphic for observed map layer
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObservedMapLayerLegend(mapLayerId: string, time: string, vertical?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObservedMapLayerLegend(mapLayerId, time, vertical, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getObservedMapLayerLegend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns metadata for an observed map layer
         * @summary Get observed map layer metadata
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObservedMapLayerMetadata(mapLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParametersObservedMapLayerMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObservedMapLayerMetadata(mapLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getObservedMapLayerMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a map tile for an observed map layer
         * @summary Get observed map layer tile
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObservedMapLayerTile(mapLayerId: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObservedMapLayerTile(mapLayerId, time, x, y, z, vertical, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getObservedMapLayerTile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns time series data for an observed parameter at a location
         * @summary Get observed parameter time series for location
         * @param {string} parameterId 
         * @param {string} locationId 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObservedParameterTimeSeriesForLocation(parameterId: string, locationId: string, unit: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParametersObservedTimeSeriesForLocationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObservedParameterTimeSeriesForLocation(parameterId, locationId, unit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.getObservedParameterTimeSeriesForLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all locations
         * @summary List locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns map layers for model
         * @summary List map layers for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMapLayersForModel(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersModeledMapLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMapLayersForModel(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listMapLayersForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest runs offered by every source of the model and fully tiled for every map layer, up to the model\'s run limit
         * @summary List runs for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listModelRuns(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersModelRun>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listModelRuns(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listModelRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all models
         * @summary List all models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listModels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listModels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all observed map layers
         * @summary List observed map layers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listObservedMapLayers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersObservedMapLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listObservedMapLayers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listObservedMapLayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all observed parameters
         * @summary List observed parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listObservedParameters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersObservedParameter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listObservedParameters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listObservedParameters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns parameters for model
         * @summary List parameters for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParametersForModel(modelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersModeledParameter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParametersForModel(modelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listParametersForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all property kinds and their available display units
         * @summary List property kinds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPropertyKinds(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParametersPropertyKind>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPropertyKinds(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParametersApi.listPropertyKinds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParametersApi - factory interface
 * @export
 */
export const ParametersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParametersApiFp(configuration)
    return {
        /**
         * Returns a legend graphic for a modeled map layer
         * @summary Get legend graphic for modeled map layer
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerLegend(modelId: string, mapLayerId: string, referenceTime: string, time: string, vertical?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getModeledMapLayerLegend(modelId, mapLayerId, referenceTime, time, vertical, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns metadata for a modeled map layer
         * @summary Get modeled map layer metadata
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerMetadata(modelId: string, mapLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ParametersModeledMapLayerMetadata> {
            return localVarFp.getModeledMapLayerMetadata(modelId, mapLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a map tile for a modeled map layer
         * @summary Get modeled map layer tile
         * @param {string} modelId 
         * @param {string} mapLayerId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {string} time Timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledMapLayerTile(modelId: string, mapLayerId: string, referenceTime: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getModeledMapLayerTile(modelId, mapLayerId, referenceTime, time, x, y, z, vertical, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time series data for a modeled parameter at specific coordinates
         * @summary Get modeled parameter time series for coordinates
         * @param {string} modelId 
         * @param {string} parameterId 
         * @param {string} referenceTime Reference time of the model run (ISO8601 format)
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeledParameterTimeSeriesForCoordinates(modelId: string, parameterId: string, referenceTime: string, latitude: number, longitude: number, unit: string, options?: RawAxiosRequestConfig): AxiosPromise<ParametersModeledTimeSeriesForCoordinatesResult> {
            return localVarFp.getModeledParameterTimeSeriesForCoordinates(modelId, parameterId, referenceTime, latitude, longitude, unit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a legend graphic for an observed map layer
         * @summary Get legend graphic for observed map layer
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp (ISO8601 format)
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerLegend(mapLayerId: string, time: string, vertical?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getObservedMapLayerLegend(mapLayerId, time, vertical, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns metadata for an observed map layer
         * @summary Get observed map layer metadata
         * @param {string} mapLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerMetadata(mapLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ParametersObservedMapLayerMetadata> {
            return localVarFp.getObservedMapLayerMetadata(mapLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a map tile for an observed map layer
         * @summary Get observed map layer tile
         * @param {string} mapLayerId 
         * @param {string} time Observation timestamp to retrieve (ISO8601 format)
         * @param {number} x X coordinate of the tile in the tiling grid
         * @param {number} y Y coordinate of the tile in the tiling grid
         * @param {number} z Zoom level of the tile in the tiling grid
         * @param {number} [vertical] Vertical coordinate to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedMapLayerTile(mapLayerId: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getObservedMapLayerTile(mapLayerId, time, x, y, z, vertical, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns time series data for an observed parameter at a location
         * @summary Get observed parameter time series for location
         * @param {string} parameterId 
         * @param {string} locationId 
         * @param {string} unit Unit code to return the time series in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObservedParameterTimeSeriesForLocation(parameterId: string, locationId: string, unit: string, options?: RawAxiosRequestConfig): AxiosPromise<ParametersObservedTimeSeriesForLocationResult> {
            return localVarFp.getObservedParameterTimeSeriesForLocation(parameterId, locationId, unit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all locations
         * @summary List locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersLocation>> {
            return localVarFp.listLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns map layers for model
         * @summary List map layers for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMapLayersForModel(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersModeledMapLayer>> {
            return localVarFp.listMapLayersForModel(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest runs offered by every source of the model and fully tiled for every map layer, up to the model\'s run limit
         * @summary List runs for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModelRuns(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersModelRun>> {
            return localVarFp.listModelRuns(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all models
         * @summary List all models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModels(options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersModel>> {
            return localVarFp.listModels(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all observed map layers
         * @summary List observed map layers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObservedMapLayers(options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersObservedMapLayer>> {
            return localVarFp.listObservedMapLayers(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all observed parameters
         * @summary List observed parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObservedParameters(options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersObservedParameter>> {
            return localVarFp.listObservedParameters(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns parameters for model
         * @summary List parameters for model
         * @param {string} modelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParametersForModel(modelId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersModeledParameter>> {
            return localVarFp.listParametersForModel(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all property kinds and their available display units
         * @summary List property kinds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPropertyKinds(options?: RawAxiosRequestConfig): AxiosPromise<Array<ParametersPropertyKind>> {
            return localVarFp.listPropertyKinds(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParametersApi - object-oriented interface
 * @export
 * @class ParametersApi
 * @extends {BaseAPI}
 */
export class ParametersApi extends BaseAPI {
    /**
     * Returns a legend graphic for a modeled map layer
     * @summary Get legend graphic for modeled map layer
     * @param {string} modelId 
     * @param {string} mapLayerId 
     * @param {string} referenceTime Reference time of the model run (ISO8601 format)
     * @param {string} time Timestamp to retrieve (ISO8601 format)
     * @param {number} [vertical] Vertical coordinate to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getModeledMapLayerLegend(modelId: string, mapLayerId: string, referenceTime: string, time: string, vertical?: number, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getModeledMapLayerLegend(modelId, mapLayerId, referenceTime, time, vertical, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns metadata for a modeled map layer
     * @summary Get modeled map layer metadata
     * @param {string} modelId 
     * @param {string} mapLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getModeledMapLayerMetadata(modelId: string, mapLayerId: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getModeledMapLayerMetadata(modelId, mapLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a map tile for a modeled map layer
     * @summary Get modeled map layer tile
     * @param {string} modelId 
     * @param {string} mapLayerId 
     * @param {string} referenceTime Reference time of the model run (ISO8601 format)
     * @param {string} time Timestamp to retrieve (ISO8601 format)
     * @param {number} x X coordinate of the tile in the tiling grid
     * @param {number} y Y coordinate of the tile in the tiling grid
     * @param {number} z Zoom level of the tile in the tiling grid
     * @param {number} [vertical] Vertical coordinate to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getModeledMapLayerTile(modelId: string, mapLayerId: string, referenceTime: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getModeledMapLayerTile(modelId, mapLayerId, referenceTime, time, x, y, z, vertical, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time series data for a modeled parameter at specific coordinates
     * @summary Get modeled parameter time series for coordinates
     * @param {string} modelId 
     * @param {string} parameterId 
     * @param {string} referenceTime Reference time of the model run (ISO8601 format)
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {string} unit Unit code to return the time series in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getModeledParameterTimeSeriesForCoordinates(modelId: string, parameterId: string, referenceTime: string, latitude: number, longitude: number, unit: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getModeledParameterTimeSeriesForCoordinates(modelId, parameterId, referenceTime, latitude, longitude, unit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a legend graphic for an observed map layer
     * @summary Get legend graphic for observed map layer
     * @param {string} mapLayerId 
     * @param {string} time Observation timestamp (ISO8601 format)
     * @param {number} [vertical] Vertical coordinate to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getObservedMapLayerLegend(mapLayerId: string, time: string, vertical?: number, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getObservedMapLayerLegend(mapLayerId, time, vertical, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns metadata for an observed map layer
     * @summary Get observed map layer metadata
     * @param {string} mapLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getObservedMapLayerMetadata(mapLayerId: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getObservedMapLayerMetadata(mapLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a map tile for an observed map layer
     * @summary Get observed map layer tile
     * @param {string} mapLayerId 
     * @param {string} time Observation timestamp to retrieve (ISO8601 format)
     * @param {number} x X coordinate of the tile in the tiling grid
     * @param {number} y Y coordinate of the tile in the tiling grid
     * @param {number} z Zoom level of the tile in the tiling grid
     * @param {number} [vertical] Vertical coordinate to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getObservedMapLayerTile(mapLayerId: string, time: string, x: number, y: number, z: number, vertical?: number, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getObservedMapLayerTile(mapLayerId, time, x, y, z, vertical, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns time series data for an observed parameter at a location
     * @summary Get observed parameter time series for location
     * @param {string} parameterId 
     * @param {string} locationId 
     * @param {string} unit Unit code to return the time series in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public getObservedParameterTimeSeriesForLocation(parameterId: string, locationId: string, unit: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).getObservedParameterTimeSeriesForLocation(parameterId, locationId, unit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all locations
     * @summary List locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listLocations(options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns map layers for model
     * @summary List map layers for model
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listMapLayersForModel(modelId: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listMapLayersForModel(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest runs offered by every source of the model and fully tiled for every map layer, up to the model\'s run limit
     * @summary List runs for model
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listModelRuns(modelId: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listModelRuns(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all models
     * @summary List all models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listModels(options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all observed map layers
     * @summary List observed map layers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listObservedMapLayers(options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listObservedMapLayers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all observed parameters
     * @summary List observed parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listObservedParameters(options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listObservedParameters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns parameters for model
     * @summary List parameters for model
     * @param {string} modelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listParametersForModel(modelId: string, options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listParametersForModel(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all property kinds and their available display units
     * @summary List property kinds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    public listPropertyKinds(options?: RawAxiosRequestConfig) {
        return ParametersApiFp(this.configuration).listPropertyKinds(options).then((request) => request(this.axios, this.basePath));
    }
}

